'use client'

import EnterViewAnimate from '@/components/enterView/animate'
import Button from '@/components/form/button'
import { ModuleName, ModuleTitle } from '@/components/layout/modules'
import { LinkArticleDetail } from '@/components/links/article'
import { Article } from '@/entities/article'
import { toSlug } from '@/lib/url'
import IconNext from '@icon/variable/next.svg'
import { cn } from '@utils'
import Image from 'next/image'
import 'swiper/css'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

export default function VideosContent({ data }: { data: Article[] }) {
  return (
    <section
      id={toSlug('Latest Videos')}
      className='py-12.5 px-4 lg:py-25 section:pr-0 section:pl-[calc((100vw-min(100vw,var(--breakpoint-section)))/2)]'
    >
      <ModuleName>LATEST VIDEOS</ModuleName>
      <div className='flex items-end justify-between section ml-0 px-0 mt-4'>
        <ModuleTitle className='max-w-135'>life at HouGarden video</ModuleTitle>
        <div className='flex gap-x-10 justify-center'>
          <NavigationButton id='videos-prev' left />
          <NavigationButton id='videos-next' />
        </div>
      </div>
      <Swiper
        modules={[Navigation]}
        slidesPerView='auto'
        spaceBetween={30}
        grabCursor
        navigation={{ prevEl: '#videos-prev', nextEl: '#videos-next' }}
        className='!pr-30 mt-12.5'
      >
        {data.map((item) => (
          <SwiperSlide className='!w-auto mr-7.5' key={item.id}>
            <EnterViewAnimate animate='animate__fadeInUp'>
              <Item data={item} />
            </EnterViewAnimate>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  )
}

function NavigationButton({ id, left }: { id: string; left?: boolean }) {
  return (
    <Button
      id={id}
      className='w-15 h-14 rounded-sm disabled:bg-[#E6E6E6] disabled:cursor-auto'
    >
      <IconNext className={cn('fill-white', { 'rotate-180': left })} />
    </Button>
  )
}

function Item({ data }: { data: Article }) {
  return (
    <LinkArticleDetail
      slug={data.slug}
      scroll={false}
      className='block max-w-107.5'
    >
      <div className='relative'>
        <Image
          src={data.coverSrc}
          width={600}
          height={318}
          alt={data.subject}
          className='w-full aspect-[600/318] object-cover'
        />
        <div className='absolute inset-0 bg-black/40 grid place-items-center'>
          {data.videoUrl && (
            <Button className='w-15 h-15 rounded-full grid place-items-center'>
              <i className='w-0 h-0 block border-8 border-r-0 border-transparent border-l-white' />
            </Button>
          )}
        </div>
      </div>
      <h6 className='font-bold mt-5 text-xl'>{data.subject}</h6>
    </LinkArticleDetail>
  )
}
